import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})

export class ProfileDialog{

  constructor(public dialogRef: MatDialogRef<ProfileDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {}
  
  close(){
    this.dialogRef.close();
  }
}